import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { showErrorToast } from '@/utils/toast.utils';

interface SetLogPatternArg {
  pattern: string;
  enabled: boolean;
}

/**
 * Enables or disables a `DEBUG` namespace pattern on the live logger and persists the
 * resulting pattern set to the `DEBUG` localStorage key so it survives a reload. A
 * persist failure still leaves the in-memory change in place (the toast reports it).
 */
export const setLogPatternThunk = createAppAsyncThunk<string[], SetLogPatternArg>(
  'debug/setLogPattern',
  ({ pattern, enabled }, { extra: { loggerService } }) => {
    const trimmedPattern = pattern.trim();
    if (trimmedPattern.length === 0) {
      return loggerService.getEnabledPatterns();
    }

    if (enabled) {
      loggerService.enable(trimmedPattern);
    } else {
      loggerService.disable(trimmedPattern);
    }

    const namespaces = loggerService.getEnabledPatterns();

    try {
      if (namespaces.length === 0) {
        globalThis.localStorage.removeItem('DEBUG');
      } else {
        globalThis.localStorage.setItem('DEBUG', namespaces.join(','));
      }
    } catch {
      showErrorToast('Could not persist log namespaces (storage unavailable)');
    }

    return namespaces;
  }
);
